import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
const BouquetsDetails = (props) => {
  const { bouquet, tabValue } = props;

  return (
    <div className='row mx-4 mt-4'>
      {tabValue === 0 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Bouquet Name</div>
            <div className='details-value preview-breaks'>{bouquet?.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Bouquet Code</div>
            <div className='details-value'>{bouquet?.code}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>No of channels</div>
            <div className='details-value'>
              {bouquet?.livetvs?.length ? bouquet?.livetvs?.length : '---'}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Floor(s)</div>
            <div className='details-value'>
              {bouquet?.floor?.length > 0 ? bouquet?.floor?.join(', ') : '---'}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Room(s)</div>
            <div className='details-value'>
              {bouquet?.room?.length > 0 ? bouquet?.room?.join(', ') : '---'}
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Location(s)</div>
            <div className='details-value'>
              {bouquet?.location?.length > 0 ? bouquet?.location?.join(', ') : '---'}
            </div>
          </div>
        </>
      )}
      {tabValue === 1 && (
        <>
          <TableContainer>
            <Table className='list-table' aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell className='w-40'>Name</TableCell>
                  <TableCell className='w-20'>Category</TableCell>
                  <TableCell className='w-20'>Code</TableCell>
                  <TableCell className='w-20'>Language</TableCell>
                  <TableCell className='w-20'>Channel Number</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bouquet.livetvs &&
                  bouquet.livetvs.length > 0 &&
                  bouquet.livetvs.map((channel, i) => (
                    <TableRow key={i} className='border-white pointer'>
                      <TableCell>{channel.name}</TableCell>
                      <TableCell>{channel.categoryName}</TableCell>
                      <TableCell>{channel.code}</TableCell>
                      <TableCell>{channel.language}</TableCell>
                      <TableCell>{channel.number}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            {(!bouquet.livetvs || bouquet.livetvs.length == 0) && (
              <div className='d-flex justify-content-center mt-2'>No records found</div>
            )}
          </TableContainer>
        </>
      )}
    </div>
  );
};

export default BouquetsDetails;
